export const NormalizeError = (err) => {
  if (!err) return null;

  var normalized = {
    message: '',
    name: '',
    stack: null,
    status: null,
    code: null,
    data: null,
    raw: err
  };

  try {
    if (typeof err === 'string') {
      normalized.message = err;
      normalized.name = 'StringError';
      return normalized;
    }

    if (err instanceof Error) {
      normalized.message = err.message || '';
      normalized.name = err.name || 'Error';
      normalized.stack = err.stack || null;
      normalized.code = err.code || null;
    }

    if (err.response) {
      normalized.status = err.response.status || null;
      normalized.name = 'HTTPError';
      normalized.data = err.response.data || null;

      if (err.response.data && err.response.data.message) {
        normalized.message = err.response.data.message;
      } else if (err.response.statusText) {
        normalized.message = err.response.statusText;
      }
    }

    if (!normalized.message && err.message) {
      normalized.message = err.message;
    }

    if (!normalized.message && err.data && err.data.message) {
      normalized.message = err.data.message;
    }

    if (!normalized.message) {
      try {
        normalized.message = JSON.stringify(err);
      } catch (e) {
        normalized.message = 'Custom error';
      }
    }

    return normalized;

  } catch (e) {
    return {
      message: 'Error normalization failed',
      raw: err
    };
  }
};
